export function handleSecondaryMenuScroll() {
    var headerHeight = document.querySelector('.site-header').offsetHeight;
    var secondaryMenu = document.querySelector('.secondary-menu');
    var siteHeader = document.querySelector('.site-header');
    var lastScrollTop = 0;
    secondaryMenu.style.marginTop = headerHeight + 'px';

    window.addEventListener('scroll', function() {
        var currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if (currentScroll > lastScrollTop && currentScroll > headerHeight) {
            // Scrolling down
            siteHeader.style.transition = 'all 0.3s ease-in-out';
            siteHeader.style.transform = 'translateY(-100%)';
            secondaryMenu.style.transition = 'margin-top 0.3s ease-in-out';
            secondaryMenu.style.marginTop = '0';
            siteHeader.classList.add('secondary-menu--hidden');
        } else {
            // Scrolling up or at the top of the page
            siteHeader.style.transition = 'all 0.3s ease-in-out';
            siteHeader.style.transform = 'translateY(0)';
            secondaryMenu.style.transition = 'margin-top 0.3s ease-in-out';
            secondaryMenu.style.transition = 'margin-top 0.3s';
            secondaryMenu.style.marginTop = headerHeight + 'px';
            if (secondaryMenu.style.marginTop === headerHeight + 'px') {
                siteHeader.classList.remove('secondary-menu--hidden');
            }
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
    });
}